﻿import React from 'react';
import DocumentHead from '../shared/DocumentHead';
import useBotPagesConfig from '../../hooks/useBotPagesConfig';
import convertMarkdownToPlainText from '../../lib/convertMarkdownToPlainText';
import { Alert } from 'reactstrap';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import BrowseQuestion from '../shared/BrowseQuestion';
import Header from '../shared/Header';
import { Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import useTrackPageView from '../../hooks/useTrackPageView.ts';

const HomePage: React.FC = () => {
    const { requiresAuthentication, pageHeader, pageSubHeader } =
        useBotPagesConfig();
    const isAuthenticated = useIsAuthenticated();

    useTrackPageView();

    if (requiresAuthentication && !isAuthenticated) {
        return <Navigate to='/auth' replace />;
    }

    const description = convertMarkdownToPlainText(pageSubHeader);

    return (
        <>
            <DocumentHead title='' description={description} />
            <Header>
                <div className='mb-4 text-center'>
                    <h1>{pageHeader || 'How can we help?'}</h1>
                </div>
                {pageSubHeader && (
                    <Alert color='info' className='hero-message' fade={false}>
                        <ReactMarkdown
                            children={pageSubHeader}
                            remarkPlugins={[remarkGfm]}
                        />
                    </Alert>
                )}
            </Header>
            <section className='home-cards'>
                <BrowseQuestion />
            </section>
        </>
    );
};

export default HomePage;
